import React from "react";
import HomePage from "./home";
function App() {
  return <HomePage />;
}

export default App;
